import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';

import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED,
	DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED,
} from '../../../common/constants.tsx';
import commonMessages from '../../../common/messages.tsx';
import { useProjectSimplified } from '../../../services/get-project/index.tsx';
import image from './assets/magnifying_glass.svg';
import messages from './messages.tsx';

export const EmptyDataMessage = () => {
	const { formatMessage } = useIntl();
	const isSimplified = useProjectSimplified();
	return (
		<Wrapper data-test-id="software-deployment-frequency-report.ui.deployment-frequency-bar-chart.empty-data-message">
			<IconContainer>
				<img src={image} alt="" />
			</IconContainer>
			<div>
				<TopMessage>{formatMessage(messages.emptyDataMessageTitle)}</TopMessage>
				<BottomMessage>
					{formatMessage(messages.emptyDataMessageDescription)}
					<LearnMore
						target="_blank"
						href={
							isSimplified === true
								? DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED
								: DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED
						}
					>
						{formatMessage(commonMessages.learnMore)}
					</LearnMore>
				</BottomMessage>
			</div>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	width: '70%',
	display: 'flex',
	alignItems: 'stretch',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 4}px`,
	marginRight: token('space.150', '12px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TopMessage = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N800),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '20px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BottomMessage = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N800),
	font: token('font.body'),
	marginTop: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LearnMore = styled.a({
	textDecoration: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.link', colors.B400),
	marginLeft: token('space.100', '8px'),
});
